<template>
  <div>
    <v-row>
      <v-col cols="6">
        <text-field-like
            v-if="readonly"
            v-model="userView.email"
            label="メールアドレス"
            hide-details>
        </text-field-like>
        <v-text-field
            v-else
            v-model="userView.email"
            label="メールアドレス"
            :readonly="readonly"
            type="email"
            :rules="[v => !!v || 'メールアドレスが必要です', rules.email]"
            @input="emitChangeForm"
            autofocus>
        </v-text-field>
      </v-col>
      <v-col cols="6">
        <text-field-like
            v-if="readonly"
            v-model="userView.name"
            label="ユーザ名"
            hide-details>
        </text-field-like>
        <v-text-field
            v-else
            v-model="userView.name"
            label="ユーザ名"
            :rules="[v => !!v || 'ユーザ名が必要です']"
            @input="emitChangeForm">
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <text-field-like
            v-if="readonly"
            v-model="userView.description"
            label="備考"
            placeholder="未設定"
            multi-line
            hide-details>
        </text-field-like>
        <v-textarea
            v-else
            v-model="userView.description"
            label="備考"
            messages="複数行入力可"
            @input="emitChangeForm"
            rows="1"
            auto-grow>
        </v-textarea>
      </v-col>
    </v-row>

    <!-- ユーザ権限 -->
    <v-card outlined class="dense mt-3">
      <v-card-title>ユーザ権限</v-card-title>
      <v-card-subtitle>ユーザの権限を選択して下さい。</v-card-subtitle>
      <v-card-text>
        <v-row dense>
          <v-col cols="3">
            <v-checkbox
                v-model="userView.permissionAdmin"
                label="管理者"
                :readonly="readonly"
                :disabled="userView.lastAdmin"
                @change="emitChangeForm"
                hide-details>
            </v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
                v-model="userView.permissionImplementation"
                label="実装"
                :readonly="readonly"
                @change="emitChangeForm"
                hide-details>
            </v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
                v-model="userView.permissionContract"
                label="取引"
                :readonly="readonly"
                @change="emitChangeForm"
                hide-details>
            </v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
                v-model="userView.permissionDictionary"
                label="辞書"
                :readonly="readonly"
                @change="emitChangeForm"
                hide-details>
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- 所属サイト -->
    <v-card outlined class="dense mt-3">
      <v-card-title>所属サイト</v-card-title>
      <v-card-subtitle>ユーザの所属サイトを選択して下さい。</v-card-subtitle>
      <v-card-text>
        <el-table :data="terminalsView" row-key="id">
          <el-table-column
              label="所属"
              prop="isSelected"
              width="60"
              header-align="center"
              align="center">
            <template #default="{row}">
              <table-inline>
                <el-checkbox
                    :value="row.isSelected"
                    @change="handleTerminalSelectionChange(row, $event)">
                </el-checkbox>
              </table-inline>
            </template>
          </el-table-column>
          <el-table-column
              :label="isCurrentLabel"
              prop="isCurrent"
              width="110"
              align="center">
            <template #default="{row}">
              <el-radio
                  :value="row.isCurrent"
                  :disabled="!row.isSelected"
                  :label="true"
                  @change="handleTerminalDefaultChange(row)"
                  class="no-label"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="name"
              label="サイト名"
              width="200">
            <template #default="{row}">
              <table-inline>
                <text-field-like
                    :value="row.name"
                    :value-id="row.id">
                </text-field-like>
              </table-inline>
            </template>
          </el-table-column>
          <el-table-column
              prop="description"
              label="説明">
            <template #default="{row}">
              <table-inline>
                <text-field-like
                    :value="row.description"
                    placeholder="未設定"
                    multi-line>
                </text-field-like>
              </table-inline>
            </template>
          </el-table-column>
        </el-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapState} from "vuex";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";

export default {
  name: 'UserForm',
  components: {TextFieldLike, TableInline},
  model: {
    prop: 'user',
    event: 'change-form'
  },
  inject: {
    form: {default: null}
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isCurrentLabel: {
      type: String,
      default: "ログイン中"
    }
  },
  created() {
    this.form && this.form.register(this);
  },
  beforeDestroy() {
    this.form && this.form.unregister(this);
  },
  data() {
    return {
      userView: {
        invalidFlag: false
      },
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'メールアドレスを入力してください'
        }
      }
    };
  },
  computed: {
    ...mapState('hcs/terminal', ['terminals']),
    terminalsView() {
      return this.terminals.map(t => ({
        ...t,
        isSelected: this.userView.availableTerminalIds?.includes(t.id) ?? false,
        isCurrent: this.userView.terminalId === t.id,
      }));
    },
    availableTerminalIds() {
      return this.userView.availableTerminalIds || [];
    },
    hasError() {
      return this.availableTerminalIds.length === 0 || !this.userView.terminalId;
    }
  },
  methods: {
    handleTerminalSelectionChange(row, selected) {
      if(this.readonly) {
        return;
      }
      const idx = this.availableTerminalIds.indexOf(row.id);
      if(selected && idx === -1) {
        this.availableTerminalIds.push(row.id);
        this.emitChangeForm();
      } else if(!selected && idx !== -1) {
        this.availableTerminalIds.splice(idx, 1);
        if(this.userView.terminalId === row.id) {
          this.userView.terminalId = '';
        }
        this.emitChangeForm();
      }
    },
    handleTerminalDefaultChange(row) {
      if(this.readonly) {
        return;
      }
      this.userView.terminalId = row.id;
      this.emitChangeForm();
    },
    emitChangeForm() {
      this.$emit('change-form', this.userView);
    },
  },
  watch: {
    user: {
      immediate: true,
      handler(value) {
        this.userView = {...value};
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.v-card.dense ::v-deep {
  .v-card__title {
    color: rgba(0, 0, 0, 0.7);
    font-size: 16px;
    padding: 10px 20px 0 20px;
  }

  .v-card__title + .v-card__subtitle {
    margin-top: 0;
  }

  .v-input--checkbox {
    margin-top: 0;
    padding-top: 0;
  }
}
</style>
